/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export class MaterialUtil {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public static getEmbeddedSgader(shaderId:string):{ vertexShader:string, fragmentShader:string } {
			return {
				vertexShader: document.getElementById(shaderId + '.vert').textContent,
				fragmentShader: document.getElementById(shaderId + '.frag').textContent
			};
		}

		public static setEmission(model:THREE.Object3D, color:THREE.Color):void {
			model.traverse((o:any):any => {
				if (o.isMesh) {
					o.material.emissive = color;
				}
			});
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------
	}
}
